const TurnTime = ({ selected, occupied, available, date, setTime }) => {
    return (
        <div
            onClick={setTime}
            style={{ border: selected ? '1px solid #0360D9' : '1px solid #DEE2E6' }}
            className={`tw-flex tw-transition-all tw-duration-300 *:tw-transition-all *:tw-duration-300 tw-flex-col ${selected && 'tw-bg-[#E6F4FF]'} tw-items-center tw-shrink-0 tw-rounded-lg tw-h-full tw-w-min tw-py-1 tw-px-2 *:tw-text-nowrap tw-flex-nowrap tw-cursor-pointer tw-select-none`}
        >
            <div className={`tw-text-[16px] ${selected && 'tw-text-[#0360D9]'} tw-font-normal`}>{date}</div>

            <div className="tw-flex tw-items-center tw-justify-evenly tw-font-normal tw-text-sm *:tw-p-0 *:tw-m-0">
                <p className="tw-text-[#52C41A]">{available + ' خالی'}</p>
                <p
                    style={{ border: selected ? '1px solid #60A4FD' : '1px solid #DEE2E6' }}
                    className="tw-w-3 tw-h-px tw-rotate-90 tw-rounded-full"
                >
                </p>
                <p className="text-danger">{occupied + ' پر'}</p>
            </div>

        </div>
    )
}

export default TurnTime;